import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ErrorScreen from '../components/ErrorScreen';
import { ErrorType } from '../lib/errorUtils';

const ErrorPage: React.FC = () => {
  const { code = 'UNKNOWN_ERROR' } = useParams<{ code?: string }>();
  const navigate = useNavigate();
  
  // Map error code to appropriate error message
  let errorMessage = 'An unexpected error occurred';
  
  switch (code) {
    case ErrorType.NETWORK:
      errorMessage = 'Unable to connect to the server. Please check your internet connection.';
      break;
    case ErrorType.AUTH:
      errorMessage = 'Authentication error. Please sign in again.';
      break;
    case ErrorType.PERMISSION:
      errorMessage = 'You don\'t have permission to access this resource.';
      break;
    case ErrorType.NOT_FOUND:
      errorMessage = 'The page you\'re looking for doesn\'t exist or has been moved.';
      break;
    case ErrorType.SERVER:
      errorMessage = 'Something went wrong on our servers. We\'re working to fix it.';
      break;
    case ErrorType.DATABASE:
      errorMessage = 'There was an issue with our database. Please try again later.';
      break;
    case ErrorType.VALIDATION:
      errorMessage = 'The data you provided is invalid. Please check your inputs.';
      break;
    case ErrorType.RENDER:
      errorMessage = 'There was a problem displaying this page. Please try refreshing.';
      break;
    default:
      errorMessage = 'Something went wrong. Please try again later.';
  }
  
  return (
    <ErrorScreen 
      code={code}
      message={errorMessage}
      onReset={() => navigate(-1)}
    />
  );
};

export default ErrorPage;